@let currencyFormat = {
  style: 'currency',
  currency: 'EUR',
  currencyDisplay: 'symbol',
  culture: lang()
};

<kendo-grid #grid [data]="gridData" [scrollable]="'scrollable'">
  <kendo-grid-column
    field="name"
    [title]="'product' | translate"
    [sticky]="true"
    [width]="140"
    [minResizableWidth]="140">
    <ng-template kendoGridCellTemplate let-dataItem>
      @if (dataItem.type === 'bike-accessory') {
        &nbsp;&#8627;&nbsp; {{ dataItem.name }}
      } @else {
        {{ dataItem.name }}
      }
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column
    headerClass="k-justify-content-center"
    class="!k-text-center"
    field="quantity"
    [title]="'quantity' | translate"
    [width]="65"
    [minResizableWidth]="65">
  </kendo-grid-column>
  <kendo-grid-column
    headerClass="k-justify-content-center"
    class="!k-text-center"
    field="height" [title]="'height' | translate"
    [width]="75"
    [minResizableWidth]="75">
  </kendo-grid-column>
  <kendo-grid-column
    [style.font-variant]="'tabular-nums'"
    headerClass="k-justify-content-center"
    class="!k-text-center"
    [format]="currencyFormat"
    field="bikePrice" [title]="'price' | translate"
    [width]="80"
    [minResizableWidth]="80">
  </kendo-grid-column>
  <kendo-grid-column
    [style.font-variant]="'tabular-nums'"
    headerClass="k-justify-content-end"
    class="!k-text-end"
    [format]="currencyFormat"
    field="price"
    [title]="'total' | translate"
    [width]="100"
    [minResizableWidth]="100">
  </kendo-grid-column>
</kendo-grid>
